module.exports = __webpack_public_path__ + "img/household_income.301705a3.svg";